/* Candela product page — mobile/tablet image slider next-button + counter
   Loaded by sections/main-product.liquid.
   Re-initializes on Shopify theme editor section reloads. */

(function () {
  function init(productInfo) {
    if (!productInfo || productInfo.dataset.candelaSliderInit === '1') return;

    var wrapper = productInfo.querySelector('.product__media-wrapper');
    if (!wrapper) return;

    var btn = wrapper.querySelector('.candela-product__slider-next');
    var counter = wrapper.querySelector('.candela-product__slider-current');
    if (!btn) return;

    var list = wrapper.querySelector('.product__media-list');
    if (!list) return;

    var slides = list.querySelectorAll('.product__media-item');
    if (slides.length < 2) return;

    var idx = 0;
    slides.forEach(function (s, i) { if (s.classList.contains('is-active')) idx = i; });

    btn.addEventListener('click', function () {
      slides[idx].classList.remove('is-active');
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add('is-active');
      if (counter) counter.textContent = idx + 1;
    });

    productInfo.dataset.candelaSliderInit = '1';
  }

  function initAll(root) {
    (root || document).querySelectorAll('product-info').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
